import { render } from "./MatchMng.vue?vue&type=template&id=9f4368fc&scoped=true"
import script from "./MatchMng.vue?vue&type=script&lang=js"
export * from "./MatchMng.vue?vue&type=script&lang=js"

import "./MatchMng.vue?vue&type=style&index=0&id=9f4368fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f4368fc"]])

export default __exports__